/**
 *  @fileOverview:首页-客户统计
 *  @creator: CaoYanqi
 *  @Date: 2019/6/6
 *  @Last Modified by: 
 *  @Last Modified time:
 */
import * as React from 'react'
import { connect } from 'react-redux'
import { Popover } from "antd";
import { Link } from "react-router-dom";
import { Utils } from '@/tools/utils';
import './dataCount.less'
import { SYSTEMPermission } from "../../../permissions/system"
import { hasPermission } from '@lima/seraphim-react';

class ClientCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.content = (
      <div className="data_count_po_tips">
        <p className="title">数据统计规则：</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及下级机构团队。</p>
        <p className="title marTop24">客户定义：</p>
        <p className="desc">保单的投保人及被保人为客户。</p>
      </div>
    );
  }
  componentDidMount() { }

  render() {
    return (
      <div className="client_count_wrap">
        <div className="header">
          <div className="title client_title">客户统计
            {
              // ?提示
              !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) &&
              <Popover placement="bottomLeft" title='' content={this.content} trigger="hover">
                <div className="count_tips"></div>
              </Popover>
            }
          </div>
          {hasPermission(SYSTEMPermission.CLIENT_MANAGEMENT) && !this.props.pageLoading && <Link to={'/clientSys/clientManage'} onClick={() => {
            Utils.customTrack('MerchantHomeClick', {
              element_content: '客户管理'
            });
          }}>客户管理</Link>}
        </div>
        <div className="client_card_wrap">
          <div className="data_card">
            <div className="card_title">客户总数</div>
            <p><span>{this.props.customerCount}</span> 位</p>
          </div>
          <div className="data_card">
            <div className="card_title">昨日新增客户</div>
            <p><span>{this.props.yesterdayCustomerCount}</span> 位</p>
          </div>
        </div>
        {
          !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) && hasPermission(SYSTEMPermission.CLIENT_MANAGEMENT) &&
          <Link to='/clientSys/clientAnalyze' className="expand_btn" onClick={() => {
            Utils.customTrack('MerchantHomeClick', {
              element_content: '客户统计-查看全部'
            });
          }}>查看全部</Link>
        }
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(ClientCount)
